import { render } from "./PhotosPage.vue?vue&type=template&id=7fc6cc00&ts=true"
import script from "./PhotosPage.vue?vue&type=script&lang=ts"
export * from "./PhotosPage.vue?vue&type=script&lang=ts"

import exportComponent from "F:\\Programming_And_Stuff\\Programming\\Stella-Maris-53-VueJSOld\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__